export default "__VITE_ASSET__Cvx$8w6D__"